import config from 'config'

// re-export flag: shall be set in models
// See definition in <repoRoot>/packages/models
export { positionTeamInviteIncludesCompany } from 'models/src/flags'

export const newSsoLogin = () => true
export const enableNewEmbeddedProfileInterview = () => config.ENABLE_NEW_EMBEDDED_PROFILE_INTERVIEW

export const newReloadOnNotFountError = () => true

// note enableCsStatistics flag is also in recruiter-backend/configs/flags.js
export const enableCsStatistics = () => config.ENABLE_CS_STATISTICS

export const timedInterviewAutomaticSubmitAndMoveForward = () => true

// note: enableUsersExport flag is also in recruiter-backend/configs/flags.js
export const enableUsersExport = () => config.ENABLE_USERS_EXPORT

export const timedInterviewAllowNotAnswerableQuestions = () =>
  config.TIMED_INTERVIEW_ALLOW_NOT_ANSWERABLE_QUESTIONS

export const enableResponseIndividualSubmit = () => config.ENABLE_RESPONSE_INDIVIDUAL_SUBMIT

export const showTutorialsButtonInNavbar = () => config.SHOW_TUTORIALS_BUTTON_IN_NAVBAR

export const enableVirtualBg = () => config.ENABLE_VIRTUAL_BG

export const enableCompanyEmailTemplates = () => config.ENABLE_COMPANY_EMAIL_TEMPLATES
